<template>
  <div
    class="import-preset"
    @keydown.stop.enter="apply(inputValue)"
  >
    <GwInput
      :placeholder="$t('solfigr.import.title')"
      type="text"
      autofocus
      :getErrors="() => (!!inputError ? [$t(`solfigr.import.error`)] : [])"
      :value="inputValue"
      @input="(_e, value) => (inputValue = value)"
      @keydown:enter="apply"
    />
  </div>
</template>

<script>
import { importRange } from '@/helpers/importFormats'
import format_mix from '@/mixins/format_mix'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'SolfigrPlayersRangesImport',
  components: { GwInput },
  mixins: [format_mix],
  props: {
    namespace: { String, required: true },
    // hasBtn: Boolean,
    // onSuccess: Function,
    // onError: Function,
  },
  emits: ['success'],
  data() {
    return {
      inputValue: '',
      inputError: false,
    }
  },
  methods: {
    apply() {
      this.inputError = false
      try {
        const res = importRange(this.inputValue)
        if (res.error) {
          this.inputError = true
          return
        }
        this.$store.dispatch('globals_action', `solfigrrangesimport_${this.inputValue}`)
        this.$emit('success')
      } catch (error) {
        // console.log(error)
        this.inputError = true
        this.inputValue = ''
        // if (this.onError) {
        //   this.onError()
        // }
      }
    },
  },
}
</script>

<style lang="scss">
.import-preset {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
